import http from "@/utils/request";

// 获取首页置顶培训班列表z
export const getTrainingList = () => {
  return http({
    url: "/shdc-edu/training/indexList",
    method: "post",
  }).then((res) => {
    if (res.code * 1 !== 200) {
      return Promise.reject(res);
    } else {
      return res.data;
    }
  });
};

// 获取首页banner列表
export const getBannerList = () => {
  return http({
    url: "/shdc-edu/common/bannerList",
    method: "post",
    data: {
      type: 0,
    },
    jsForm: true,
  }).then((res) => {
    if (res.code * 1 !== 200) {
      return Promise.reject(res);
    } else {
      return res.data;
    }
  });
};

// 获取培训班信息列表
export const getTrainingListData = (data) => {
  return http({
    url: "/shdc-edu/training/list",
    method: "post",
    data,
  }).then((res) => {
    if (res.code * 1 !== 200) {
      return Promise.reject(res);
    } else {
      return res.data;
    }
  });
};

// 获取培训班详情
export const getTrainingDetaila = (trainingUuid) => {
  return http({
    url: "/shdc-edu/training/getTrainingDetail",
    method: "get",
    params: {
      trainingUuid,
    },
  }).then((res) => {
    if (res.code * 1 !== 200) {
      return Promise.reject(res);
    } else {
      return res.data;
    }
  });
};
